export default __webpack_public_path__ + "static/media/background_espace_responsable.0c89a8bd.jpg";